import React, { useState } from "react";
import { FiX } from "react-icons/fi";
import RazorpayIcon from "../../assets/images/razorpay.png";
import UpiIcon from "../../assets/images/upi.webp";
import VisaIcon from "../../assets/images/visa.png";
import MasterCardIcon from "../../assets/images/mastercard.png";

const PaymentPopup = ({ onClose, onContinue,selectedPartner }) => {
  const [selectedMethod, setSelectedMethod] = useState("razorpay");

  const handleContinue = () => {
    onContinue(selectedMethod);
  };

  return (
    <div className="PaymentPopupOverlay">
      <div className="PaymentPopup">
        {/* Header */}
        <div className="PopupHeader">
          <div>
            <h3>Choose Your Payment Method</h3>
            <p>Please select a payment option to complete your order.</p>
          </div>
          <button className="CloseBtn" onClick={onClose}>
            <FiX />
          </button>
        </div>

        {/* Payment Options */}
        <div className="PaymentOptions">
          {/* Razorpay Option */}
          <label className="PaymentOption">
            <input
              type="radio"
              name="paymentMethod"
              value="razorpay"
              checked={selectedMethod === "razorpay"}
              onChange={() => setSelectedMethod("razorpay")}
            />
            <div className="OptionContent">
              <img src={RazorpayIcon} alt="Razorpay" className="MainIcon" />
              <div className="OtherIcons">
                <img src={UpiIcon} alt="UPI" />
                <img src={VisaIcon} alt="Visa" />
                <img src={MasterCardIcon} alt="MasterCard" />
              </div>
            </div>
          </label>

          {/* Cash on Delivery Option */}
          {selectedPartner === 'ecart' && (
            <label className="PaymentOption" >
              <input
                type="radio"
                name="paymentMethod"
                value="cod"
                checked={selectedMethod === "cod"}
                onChange={() => setSelectedMethod("cod")}
              />
              <span className="CodText">Cash on Delivery</span>
            </label>
          )}
          
        </div>

        
        <div className="PopupFooter">
          <button onClick={handleContinue}>
            Continue with{" "}
            {selectedMethod === "razorpay" ? "Razorpay" : "Cash on Delivery"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentPopup;
